export default "__VITE_ASSET__VcE0KVOc__"